module.exports = __webpack_public_path__ + "img/Tuerca.822a7de1.svg";